import {Type} from 'typebox'
import type {SafeHTMLString} from '@github-ui/safe-html'

// Core Type Builder
export {Type} from 'typebox'

//  Static Type Inference
export type {Static, StaticDecode, StaticEncode} from 'typebox'

/**
 * Schema for a `SafeHTMLString`.
 *
 * Typically used within other schema definitions, for example: `titleHtml: SafeHTML`.
 * @param options Optional configuration to pass to underlying `Type.String`.
 */
export const SafeHTML = (options?: Type.TStringOptions) => Type.Unsafe<SafeHTMLString>(Type.String(options))

// Common Schema Types
export type {
  TSchema,
  TSchemaOptions,
  TAny,
  TUnknown,
  TNever,
  TNull,
  TUndefined,
  TVoid,
  TString,
  TStringOptions,
  TNumber,
  TNumberOptions,
  TInteger,
  TBoolean,
  TArray,
  TArrayOptions,
  TObject,
  TObjectOptions,
  TProperties,
  TTuple,
  TTupleOptions,
  TUnion,
  TIntersect,
  TIntersectOptions,
  TLiteral,
  TLiteralValue,
  TEnum,
  TEnumValue,
  TRecord,
  TRecordKey,
  TRef,
  TThis,
  TFunction,
  TConstructor,
  TSymbol,
  TBigInt,
  TFormat,
} from 'typebox'

// Modifiers
export type {TOptional, TReadonly, TImmutable} from 'typebox'

// Type Guards
export {IsSchema, IsKind, IsOptional, IsReadonly} from 'typebox'

// Utility Types
export type {
  TPartial,
  TRequired,
  TPick,
  TOmit,
  TKeyOf,
  TExtends,
  TExclude,
  TExtract,
  TNonNullable,
  TReturnType,
  TInstanceType,
  TParameters,
  TConstructorParameters,
} from 'typebox'

// Advanced Types
export type {
  TTemplateLiteral,
  TCapitalize,
  TUncapitalize,
  TUppercase,
  TLowercase,
  TMapped,
  TConditional,
  TIndex,
  TRest,
  TUnsafe,
  TRefine,
} from 'typebox'
